import React from 'react';
import styled from 'styled-components/macro';
import { EwalletInfo } from '../../interfaces/ewallet-info';
import GRADES from '../../constants/grades';
import arrow from '../../resources/images/chevron.left.svg';
import { formatCurrencyNumber } from '../../utils/amountFormat';

interface Props {
	item: EwalletInfo;
	payment?: boolean;
	handleClick?: any;
}

const EwalletCard = ({ item, payment, handleClick }: Props) => {
	let name = '';
	if (item.studentFirstName === '' && item.studentLastName === '') {
		name = item.teacherLastName;
		if (item.teacherFirstName) {
			name += `, ${item.teacherFirstName}`;
		}
	} else {
		name = `${item.studentLastName}, ${item.studentFirstName}`;
	}

	return (
		<>
			<StyledCard payment={payment} onClick={handleClick}>
				<StyledCardHeader>
					<StyledNameDiv>
						<StyledNameText>{name}</StyledNameText>
					</StyledNameDiv>
					<StyledDollarAmount>{formatCurrencyNumber(item.amount.toNumber())}</StyledDollarAmount>
				</StyledCardHeader>
				<StyledCardDetails>
					<StyledWhiteBoarder>
						<StyledInnerText>Grade: {GRADES.map((obj) => (obj.value === item.grade.toLowerCase() ? obj.tile : ''))}</StyledInnerText>
					</StyledWhiteBoarder>
					<BottomRow>
						<StyledWhiteBoarder>
							<StyledInnerText>
								Teacher: {item.teacherFirstName} {item.teacherLastName}
							</StyledInnerText>
						</StyledWhiteBoarder>
						{payment && <StyledImg src={arrow} />}
					</BottomRow>
				</StyledCardDetails>
			</StyledCard>
		</>
	);
};

interface StyledCardProps {
	payment?: boolean;
}

const StyledCard = styled.div<StyledCardProps>`
    display: flex;
    flex-direction: column;
    width: 280px
    min-height: 136px;
    background: #EBF4FF;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 17px 20px 24px 24px;
    justify-content: space-between;
    gap: 20px;
    cursor: ${(props) => (props.payment ? 'pointer' : 'auto')};
`;

const StyledCardHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
`;

const StyledNameDiv = styled.div`
	flex: 1;
	word-wrap: break-word;
	overflow: hidden;
	margin-right: 5px;
`;

const StyledNameText = styled.p`
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	line-height: 19px;
	color: #333333;
	margin: 0;
	text-align: left;
`;

const StyledDollarAmount = styled.p`
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 19px;
	color: #333333;
	margin: 0;
	white-space: nowrap;
`;

const StyledCardDetails = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

const StyledInnerText = styled.p`
	font-size: 13px;
	font-style: normal;
	font-weight: 400;
	line-height: 15px;
	color: #333333;
	margin: 0;
	word-wrap: break-word;
`;

const StyledWhiteBoarder = styled.div`
	padding: 5px 12px;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;
	border-radius: 50px;
	background: #fff;
	box-sizing: border-box;
	width: fit-content;
	max-width: calc(100% - 16px);
	margin-right: 5px;
	word-wrap: break-word;
	white-space: normal;
`;

const BottomRow = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
`;

const StyledImg = styled.img`
	width: 11.421px;
	height: 19.878px;
	margin-left: auto;
	transform: scaleX(-1);
	filter: invert(25%) sepia(70%) saturate(50%) hue-rotate(180deg) brightness(50%) contrast(90%);
`;

export default EwalletCard;
